/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

// import Button from '../../common/Button'; (ENGA-1367)
// import SharePreviewPopover from './SharePreviewPopover'; (ENGA-1367)

const SharePreviewButton = ({
  // eslint-disable-next-line no-unused-vars
  pressReleasePreviewUrl,
}) => {
  return <></>;
  // PRESS RELEASE PREVIEW HAS BEEN DISABLE AND WILL LIKELY BE REMOVED (ENGA-1367)
  //
  // const popoverTargetID = 'share_preview_button';
  //
  // return (
  //   <>
  //     <Button
  //       id={popoverTargetID}
  //       buttonClassName="button--medium"
  //       extraClassName="confirmation__button"
  //       as="button"
  //       type="button"
  //     >
  //       {/* eslint-disable-next-line global-require */}
  //       <img className="button__icon button__icon--left" src={require('../../common/img/svg/share.svg')} alt="" />
  //       Share preview
  //     </Button>
  //     <SharePreviewPopover
  //       pressReleasePreviewUrl={pressReleasePreviewUrl}
  //       popoverTargetID={popoverTargetID}
  //     />
  //   </>
  // );
};

SharePreviewButton.propTypes = {
  pressReleasePreviewUrl: PropTypes.string.isRequired,
};

export default SharePreviewButton;
